module.exports = __webpack_public_path__ + "static/media/7.b359e38d.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/7.png
// module id = 54
// module chunks = 0